<h3 class="max-w-[80%] m-auto text-center text-m">
  {{ "CREATE_NEW_COLLECTION" | translate }}
</h3>
<form [formGroup]="createList" (ngSubmit)="onSubmit()" class="!mb-0">
  <input
    type="text"
    formControlName="name"
    placeholder="{{ 'NAME' | translate }}"
  />
  @if (createList.get('name')?.touched) { @if
  (createList.get('name')?.hasError('required')) {
  <div class="error">
    {{ "NAME_REQUIRED" | translate }}
  </div>
  } }

  <input
    type="text"
    formControlName="description"
    placeholder="{{ 'DESCRIPTION' | translate }}"
  />

  <div class="pr-1 mb-2">
    <mat-slide-toggle
      formControlName="isPrivate"
      labelPosition="before"
      class="toggles w-full"
    >
      <div class="slideLabel flex justify-start items-center">
        <div
          class="inner w-[36px] h-[36px] rounded-full bg-whitepale dark:bg-black-dark-light mr-[12px]"
        >
          <span
            class="block w-[24px] h-[24px] mt-[6px] ml-[6px] bg-black dark:bg-white"
            style="
              -webkit-mask: url(&quot;/assets/images/icons/lock.svg&quot;);
              mask: url(&quot;/assets/images/icons/lock.svg&quot;);
              -webkit-mask-size: 24px 24px;
              mask-size: 24px 24px;
            "
          ></span>
        </div>
        {{ "PRIVATE" | translate }}
      </div>
    </mat-slide-toggle>
    <p class="max-w-[80%] text-grey dark:text-borders-dark -mt-1 pl-6">
      {{ "PRIVATE_TEXT" | translate }}
    </p>
  </div>

  <div class="pr-1 mb-2">
    <mat-slide-toggle
      formControlName="isCollaborative"
      labelPosition="before"
      class="toggles w-full"
    >
      <div class="slideLabel flex justify-start items-center">
        <div
          class="inner w-[36px] h-[36px] rounded-full bg-whitepale dark:bg-black-dark-light mr-[12px]"
        >
          <span
            class="block w-[24px] h-[24px] mt-[6px] ml-[6px] bg-black dark:bg-white"
            style="
              -webkit-mask: url(&quot;/assets/images/icons/collaborators.svg&quot;);
              mask: url(&quot;/assets/images/icons/collaborators.svg&quot;);
              -webkit-mask-size: 24px 24px;
              mask-size: 24px 24px;
            "
          ></span>
        </div>
        {{ "COLLABORATIVE" | translate }}
      </div>
    </mat-slide-toggle>
    <p class="max-w-[80%] text-grey dark:text-borders-dark -mt-1 pl-6">
      {{ "COLLABORATIVE_TEXT" | translate }}
    </p>
  </div>

  <button type="submit">{{ submitText }}</button>
</form>
